import { forwardRef, type ReactNode } from 'react';
import type { StickyShell } from './use-sticky-shell';

export const StickyPatientBar = forwardRef<HTMLDivElement, { children: ReactNode }>(function StickyPatientBar({ children }, ref) {
  return (
    <div ref={ref} className="relative z-20 -mx-4 -mt-4 mb-1 bg-background no-print md:sticky md:top-[var(--emr-bar-top,0px)] lg:-mx-6 lg:-mt-6">
      <div className="bg-muted/30 px-4 pb-3 pt-4 lg:px-6 lg:pt-6">
        <div className="overflow-hidden rounded-2xl border bg-card shadow-[0_8px_24px_-12px_rgb(15_23_42/0.25)] dark:shadow-[0_8px_24px_-12px_rgb(0_0_0/0.7)]">{children}</div>
      </div>
    </div>
  );
});

export function ClinicalShell({
  shell,
  bar,
  banners,
  nav,
  activeKey,
  children,
}: {
  shell: StickyShell;
  bar: ReactNode;
  banners?: ReactNode;
  nav: ReactNode;
  activeKey: string;
  children: ReactNode;
}) {
  return (
    <div ref={shell.attachPage} className="[--emr-bar-top:-1.5rem] lg:[--emr-bar-top:-2.5rem]" style={shell.style}>
      {bar}
      <div className="mb-4 space-y-3 empty:hidden">{banners}</div>
      <div className="grid gap-4 lg:grid-cols-[15rem_minmax(0,1fr)] xl:grid-cols-[16rem_minmax(0,1fr)]">
        <aside className="min-w-0">{nav}</aside>
        <div key={activeKey} className="min-w-0 space-y-4 animate-in fade-in-0 slide-in-from-bottom-1 duration-200">
          {children}
        </div>
      </div>
    </div>
  );
}
